import React from 'react';
import { getApiBaseUrl } from '../api/client';

/**
 * Shared error state for dashboard (desktop and mobile).
 */
export default function ErrorView({ message, onRetry, error, mobile = false }) {
  const isNetworkError = (message || '').toLowerCase().includes('network error');
  const apiBase = getApiBaseUrl() || '(same-origin)';
  const displayMessage = message || 'Unknown error';
  const errorDetails = error?.response?.data ?? error;

  const content = (
    <>
      <p className="error">Error loading data: {displayMessage}</p>
      <p style={{ fontSize: '0.8em', marginTop: '10px', color: mobile ? '#aaa' : undefined }}>
        Make sure the backend is running and accessible. API base: {apiBase}
      </p>
      {isNetworkError && (
        <p style={{ fontSize: '0.8em', marginTop: '6px', color: mobile ? '#888' : '#aaa' }}>
          {mobile
            ? 'Start backend: uvicorn backend.api.main:app --port 8001'
            : 'If running locally, start the backend: '}
          {!mobile && (
            <code style={{ fontSize: '0.9em' }}>
              python3 -m uvicorn backend.api.main:app --reload --port 8001
            </code>
          )}
        </p>
      )}
      <button
        type="button"
        onClick={onRetry}
        style={{
          marginTop: mobile ? '16px' : '10px',
          padding: mobile ? '10px 20px' : '8px 16px',
          cursor: 'pointer',
        }}
      >
        Retry
      </button>
      {!mobile && (
        <details style={{ fontSize: '0.75em', marginTop: '12px', textAlign: 'left', maxWidth: '90%' }}>
          <summary>Error details</summary>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {JSON.stringify(errorDetails, null, 2)}
          </pre>
        </details>
      )}
    </>
  );

  if (mobile) {
    return (
      <div className="App mobile-app">
        <div className="mobile-content-wrapper">
          <div style={{ padding: '40px', textAlign: 'center', color: '#ef4444' }}>
            {content}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>Funding Rate Monitor</h1>
        {content}
      </header>
    </div>
  );
}
